import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=5e27f883&scoped=true"
import script from "./ModalRoot.vue?vue&type=script&lang=js"
export * from "./ModalRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27f883",
  null
  
)

export default component.exports